import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';

import { IIssuesObservationTableData } from '../TestMonitoringTab/TestMonitoringDataTable/api/type-def';

import {
	IPendingActionItemTableData,
	ITestAreaData,
	ITestMonitoringTestStatusTable,
	ITestPlanDetails,
	ITestResultsTableData,
	ITestSelectControlData,
	IControlTestStepsRequestParams,
} from './type-def';

const { REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL } = process.env;

export const getTestStatus = async () => {
	const resp = await apiWrapper.get<
		ITestMonitoringTestStatusTable[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-plan`);
	return resp;
};
export const getIssuesObservationTableData = async () => {
	const resp = await apiWrapper.get<
		IIssuesObservationTableData[],
		IAPIErrorContent
	>(`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-issues`);

	return resp;
};
export const getPendingActionItemsTableData = async () => {
	const resp = await apiWrapper.get<
		IPendingActionItemTableData[],
		IAPIErrorContent
	>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-action-items`,
	);
	return resp;
};

export const getTestResultsTableData = async () => {
	const resp = await apiWrapper.get<ITestResultsTableData[], IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-results`,
	);

	return resp;
};
export const getTestSelectionTestPlanDetails = async () => {
	const resp = await apiWrapper.get<ITestPlanDetails[], IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-plan-details`,
	);

	return resp;
};
export const getTestSelectionTestAreaDetails = async (id: string) => {
	const resp = await apiWrapper.get<ITestAreaData[], IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-area/filterByTestPlan/${id}`,
	);

	return resp;
};
export const getTestSelectionControlDetails = async (id: string) => {
	const resp = await apiWrapper.get<ITestSelectControlData, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/test-area/filterByTestArea/${id}`,
	);

	return resp;
};

export const getGenAITestScripts = async (id: string) => {
	const resp = await apiWrapper.get<any, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/gen-ai/test-steps/${id}`,
	);

	return resp;
};

export const createSelectedControlTestSteps = async (
	params: IControlTestStepsRequestParams,
) => {
	const resp = await apiWrapper.post<any, IAPIErrorContent>(
		`${REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/test-monitor/gen-ai/test-steps`,
		params,
	);
	return resp;
};
